import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Users, MessageSquare, Store, Database, Code, ChevronDown, ChevronRight, Network, Play, BookOpen } from 'lucide-react';
interface SidebarProps {
  userRole: 'Program Manager' | 'Founder';
}
const Sidebar: React.FC<SidebarProps> = ({
  userRole
}) => {
  const [agentsExpanded, setAgentsExpanded] = useState(true);
  const toggleAgentsMenu = () => {
    setAgentsExpanded(!agentsExpanded);
  };
  const navItems = [{
    name: 'Dashboard',
    path: '/',
    icon: <LayoutDashboard size={20} data-id="element-35" />
  }, {
    name: 'Program',
    path: '/program',
    icon: <BookOpen size={20} data-id="element-36" />
  }, {
    name: 'Ventures',
    path: '/ventures',
    icon: <Users size={20} data-id="element-37" />
  }, {
    name: 'People',
    path: '/people',
    icon: <Network size={20} data-id="element-38" />
  }, {
    name: 'Insights',
    path: '/data-vault',
    icon: <Database size={20} data-id="element-39" />
  }];
  return <div className="w-64 bg-white border-r border-gray-200 flex flex-col" data-id="element-40">
      <div className="p-4 border-b border-gray-200" data-id="element-41">
        <h1 className="text-xl font-semibold text-gray-800" data-id="element-42">Kalphai</h1>
        <p className="text-xs text-gray-500" data-id="element-43">Eshelman Innovation Kairos</p>
      </div>
      <nav className="flex-1 p-4" data-id="element-44">
        <ul className="space-y-1" data-id="element-45">
          {navItems.map(item => <li key={item.name} data-id="element-46">
              <NavLink to={item.path} className={({
            isActive
          }) => `flex items-center px-4 py-3 rounded-md transition-colors ${isActive ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-47">
                <span className="mr-3" data-id="element-48">{item.icon}</span>
                <span data-id="element-49">{item.name}</span>
              </NavLink>
            </li>)}
          {/* Agents with submenu */}
          <li data-id="element-50">
            <div className="flex items-center justify-between px-4 py-3 rounded-md cursor-pointer text-gray-700 hover:bg-gray-100" onClick={toggleAgentsMenu} data-id="element-51">
              <div className="flex items-center" data-id="element-52">
                <span className="mr-3" data-id="element-53">
                  <MessageSquare size={20} data-id="element-54" />
                </span>
                <span data-id="element-55">Agents</span>
              </div>
              <span data-id="element-56">
                {agentsExpanded ? <ChevronDown size={16} data-id="element-57" /> : <ChevronRight size={16} data-id="element-58" />}
              </span>
            </div>
            {agentsExpanded && <ul className="mt-1 ml-7 space-y-1" data-id="element-59">
                <li data-id="element-60">
                  <NavLink to="/agents" className={({
                isActive
              }) => `flex items-center px-4 py-2 rounded-md transition-colors ${isActive ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-61">
                    <span className="mr-3" data-id="element-62">
                      <Play size={16} data-id="element-63" />
                    </span>
                    <span data-id="element-64">Run</span>
                  </NavLink>
                </li>
                <li data-id="element-65">
                  <NavLink to="/build" className={({
                isActive
              }) => `flex items-center px-4 py-2 rounded-md transition-colors ${isActive ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-66">
                    <span className="mr-3" data-id="element-67">
                      <Code size={16} data-id="element-68" />
                    </span>
                    <span data-id="element-69">Build</span>
                  </NavLink>
                </li>
                <li data-id="element-70">
                  <NavLink to="/marketplace" className={({
                isActive
              }) => `flex items-center px-4 py-2 rounded-md transition-colors ${isActive ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-71">
                    <span className="mr-3" data-id="element-72">
                      <Store size={16} data-id="element-73" />
                    </span>
                    <span data-id="element-74">Marketplace</span>
                  </NavLink>
                </li>
              </ul>}
          </li>
        </ul>
      </nav>
      <div className="p-4 text-xs text-gray-500 border-t border-gray-200" data-id="element-75">
        <p data-id="element-76">v1.0.0</p>
      </div>
    </div>;
};
export default Sidebar;